import { z } from 'zod'

export const ProductTypeSchema = z.enum(['CAR_HIRE', 'EXPERIENCE', 'HOTEL'])

export type ProductType = z.infer<typeof ProductTypeSchema>
